import { ReactLenis } from "lenis/react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { Grain } from "./components/Grain";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { TaglineMarquee } from "./components/TaglineMarquee";
import { Manifesto } from "./components/Manifesto";
import { Zones } from "./components/Zones";
import { Programs } from "./components/Programs";
import { LandingPackages } from "./components/LandingPackages";
import { Consultants } from "./components/Consultants";
import { Venue } from "./components/Venue";
import { Gallery } from "./components/Gallery";
import { Contact } from "./components/Contact";
import StoryPage from "./components/StoryPage";
import { Footer } from "./components/Footer";
import { AuthProvider } from "./hub/auth/AuthContext";
import { ProtectedRoute, AdminRoute } from "./hub/auth/ProtectedRoute";
import { HubBodyTheme } from "./hub/components/HubBodyTheme";
import { Layout } from "./hub/components/Layout";
import LoginPage from "./hub/pages/LoginPage";
import Dashboard from "./hub/pages/Dashboard";
import CalendarView from "./hub/pages/CalendarView";
import Groups from "./hub/pages/Groups";
import Packages from "./hub/pages/Packages";
import Activities from "./hub/pages/Activities";
import HubZones from "./hub/pages/Zones";
import Invoices from "./hub/pages/Invoices";
import Settings from "./hub/pages/Settings";
import Mailbox from "./hub/pages/Mailbox";
import Contacts from "./hub/pages/Contacts";
import EmailCenter from "./hub/pages/EmailCenter";
import PublicBooking from "./hub/pages/PublicBooking";

function Landing() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App bg-forest min-h-screen" data-testid="lush-adventure-app">
        <Grain />
        <Navbar />
        <main>
          <Hero />
          <TaglineMarquee />
          <Manifesto />
          <Zones />
          <Programs />
          <Consultants />
          <LandingPackages />
          <Venue />
          <Gallery />
          <Contact />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <HubBodyTheme />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/book" element={<PublicBooking />} />
          <Route path="/story" element={<StoryPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/hub" element={<Dashboard />} />
            <Route path="/hub/calendar" element={<CalendarView />} />
            <Route path="/hub/groups" element={<Groups />} />
            <Route path="/hub/groups/:id" element={<Groups />} />
            <Route path="/hub/packages" element={<Packages />} />
            <Route path="/hub/activities" element={<Activities />} />
            <Route path="/hub/zones" element={<HubZones />} />
            <Route path="/hub/invoices" element={<Invoices />} />
            <Route path="/hub/mailbox" element={<Mailbox />} />
            <Route path="/hub/contacts" element={<Contacts />} />
            <Route path="/hub/email" element={<EmailCenter />} />
            <Route
              path="/hub/settings"
              element={
                <AdminRoute>
                  <Settings />
                </AdminRoute>
              }
            />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
